var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('noscript',[_c('div',[_c('img',{staticStyle:{"position":"absolute","left":"-9999px"},attrs:{"src":"https://mc.yandex.ru/watch/94789753","alt":""}})])])])
}]

export { render, staticRenderFns }